export default {
  "aor": {
    "action": {
      "add_filter": "Add filter",
      "back": "Go Back",
      "cancel": "Cancel",
      "close": "Close",
      "create": "Create",
      "delete": "Delete",
      "edit": "Edit",
      "list": "List",
      "refresh": "Refresh",
      "remove_filter": "Remove this filter",
      "save": "Save",
      "show": "Show"
    },
    "auth": {
      "avatar": "Your Photo URL (optional)",
      "bio": "Short Bio (optional)",
      "education": "Your Education (optional)",
      "email": "Email",
      "first_name": "First Name (optional)",
      "last_name": "Last Name (optional)",
      "logged_in": "Logged in",
      "logged_out": "Logged out",
      "logging_in": "Logged in",
      "login": "Login",
      "logout": "Logout",
      "name": "Name",
      "password": "Password",
      "sign_in": "Sign in",
      "sign_in_error": "Authentication failed, please retry",
      "sign_up": "Sign up",
      "sign_up_error": "Sign up failed, please retry",
      "signing_up": "Signed up",
      "username": "Username",
      "website": "Your Website (optional)"
    },
    "boolean": {
      "false": "No",
      "true": "Yes"
    },
    "edit_profile": "Edit Profile",
    "input": {
      "autocomplete": {
        "none": ""
      },
    },
    "message": {
      "about": "About",
      "are_you_sure": "Are you sure?",
      "no": "No",
      "not_found": "Either you typed a wrong URL, or you followed a bad link.",
      "yes": "Yes"
    },
    "navigation": {
      "next": "Next",
      "no_more_results": "No more results found",
      "no_results": "This entity hasn't been modified: no history to show",
      "page_out_from_begin": "Cannot go before page 1",
      "page_out_from_end": "Cannot go after last page",
      "page_out_of_boundaries": "Page number %{page} out of boundaries",
      "page_range_info": "%{offsetBegin}-%{offsetEnd} of %{total}",
      "prev": "Prev"
    },
    "notification": {
      "created": "Successfully created",
      "deleted": "Successfully deleted",
      "http_error": "Server communication error",
      "item_doesnt_exist": "Element does not exist",
      "updated": "Successfully updated"
    },
    "page": {
      "create": "Create %{name}",
      "dashboard": "Dashboard",
      "delete": "Delete %{name} #%{id}",
      "edit": "%{name} #%{id}",
      "list": "%{name} List",
      "not_found": "Not Found",
      "show": "%{name} #%{id}"
    },
    "profile_image": "Avatar",
    "validation": {
      "email": "Must be a valid email",
      "maxLength": "Must be %{max} characters or less",
      "maxValue": "Must be %{max} or less",
      "minLength": "Must be %{min} characters at least",
      "minValue": "Must be at least %{min}",
      "number": "Must be a number",
      "required": "Required"
    }
  },
  "askQuestion": "Ask question",
  "auth": {
    "logged_in": "Logged in",
    "logged_out": "Logged out",
    "login": "Login",
    "logout": "Logout",
    "sign_in": "Sign In",
    "sign_up": "Join"
  },
  "chartSunburst": {
    "breakdownTitle": "Breakdown of %{dontTranslate} subjects",
    "hoverClickItems": "hover/ click items",
    "switchChart": "SWITCH CHART"
  },
  "influence": {
    "year": "Year",
    "provinces": "Provinces",
    "populationTotal": "Population Total",
    "populationShare": "Population Share",
  },
  "community": {
    "biographyShort": "Bio",
    "board": "Board",
    "highscore": "Member Data Highscore",
    "memberSince": "member since",
    "myProfile": "My Profile",
    "supportingMember": "Supporting Members",
    "totalPoints": "Total Points",
    "loginCount": "Login Count",
    "voteCount": "Vote Count",
    "createCount": "Create Count",
    "editCount": "Edit Count",
    "deleteCount": "Delete Count",
    "mistakesCount": "Mistakes Count",
    "revertCount": "Revert Count",
    "linkedCount": "Linked Count",
  },
  "didYouKnow": {
    "escape": "You can close opened articles by pressing Escape key",
    "coloring": "You can change map coloring to religion, culture or population via the layers icon on the menu bar",
    "discover": "You can browse images and other media by clicking the compass icon on the menu bar",
    "distribution": "You can see a complete distribution of people of a realm by clicking the circle chart icon on an article",
    "link": "You can link any articles together to show up in a content section (articles) or the media section",
    "markerlimit": "You can improve performance by decreasing marker count via the layers icon on the menu bar",
    "province": "You can see a complete history of a province by clicking Province on the article header",
    "question": "You can ask questions about articles and answer others in the Forum",
    "timeline": "You can mouse scroll the timeline to scale"
  },
  "introHints": {
    step1: "Scroll to zoom and click anywhere on the timeline (1/3)",
    step2: "Open the Layers menu and select some Markers and Epics (2/3)",
    step3: "Open the Media menu to browse images, videos etc. related to selected year (3/3)",
    stepFinal: "Those are the basics. There are tons of other features waiting for you to discover. Enjoy the journey!",
    close: "Close introduction"
  },
  benchmarkPage: {
    tier5Header: "None",
    title: "Detault settings",
    tier1Header: "Clean & Fast",
    tier1Description: "Only map borders and labels",
    tier2Header: "Intermediate",
    tier2Description: "Borders, labels and a maximum of 2000 markers per year",
    tier3Header: "Complete",
    tier3Description: "Epics in timeline and a maximum of 5000 markers per year",
    suggestion1: "We suggest <b>%{dontTranslate}</b> based on ",
    suggestion2: "your machine's specs",
    warning1: "While mobile support is on our roadmap, we do not have a mobile version yet. Please check back later.",
    warning2: "While tablet support is on our roadmap, we do not support touch screens yet. Please check back later.",
    continue: "continue",
    specsTitle: "Your Machine's Specs",
    hint: "You can customize all settings through the layers menu later."
  },
  collections: {
    "new": "Add Collection",
    "my": "My Collections",
    "public": "Public Collections",
    "title": "Collections",
    "quiz": {
      title: "Quiz",
      addQuestion: "Add Question",
      addAnswer: "Add Answer",
      answer: "Answer",
      isCorrect: "Correct Answer?",
      question: "Question"
    }
  },
  "loadingPage": {
    "errorMessage": "Chronas seems to be under too much load right now. Please try again in a couple of minutes.",
    "loadingScreenDescription": {
      "218": "Young Roman emperor Elagabalus (203-222 AD) hosting a banquet",
      "400": "Honorius, Son of Theodosius I; appointed as junior Augustus for the west by Theodosius in 393",
      "450": "450-511: Education of the Children of Clovis",
      "711": "711: Battle of Guadalete of the Visigoths and the beginning of the Umayyad conquest of Hispania",
      "881": "881: Battle of Danish forces of pagan Viking warriors and the Christian troops of Carolingian",
      "1121": "1121: The aftermath of the Didgori battle portrayed in \"Spirit of the Rider\" made by Augusto Ferrer-Dalmau",
      "1331": "1331: Siege of Akasaka near Osaka was one of the earlier battles of the Genkō War",
      "1582": "1582: Battle of Chuvash Cape",
      "1627": "1627–1628: Siege of La Rochelle (Kingdom of France)",
      "1649": "1649: Cromwell at Dunbar. Oliver Cromwell united the whole of the British Isles by force and created the Commonwealth of England",
      "1832": "1832: Pont Neuf bridge in Paris",
      "1862": "1862: Confederate prisoners captured in the Battle of Front Royal",
      "1871": "1871: Proclamation of the German Empire in Versailles",
      "-1400": "1400 BC: The Trundholm sun chariot, is a Nordic Bronze Age artifact discovered in Denmark.",
      "-2000": "26th century BC: The Standard of Ur, a hollow wooden box with scenes of war and peace",
      "-332": "332 BCE: Alexander the Great's uncontested entry into the city of Babylon",
      "-519": "519 BC: Lucius Quinctius became a legendary Roman opponent of the rights of the plebeians (the common citizens)",
      "-52": "52 BCE: The surrender of the Gallic chieftain after the Battle of Alesia",
      "-600": "605-562 BCE: Striding Lion, Neo-Babylonian Empire",
      "-620": "620-570 BCE: Sappho and Alcaeus",
      "-668": "668 BC: Sculpted reliefs depicting Ashurbanipal, the last great Assyrian king, hunting lions"
    }
  },
  "pos": {
    "about": "About Chronas",
    "account": "Manage Account",
    "addMedia": "Add Media",
    "advanced": "Advanced",
    "area": "Area",
    "areas": "Areas",
    "back": "back",
    "basemap": "Basemap",
    "basemapTypes": {
      "none": "None",
      "topographic": "Topographic",
      "watercolor": "Watercolor"
    },
    "bookmark": "bookmark",
    "block": {
      "about1": "<h4>What is Chronas?</h4> <br /> <h5>In Brief</h5>",
      "about2": "Chronas may be described as a mix of <a target='_blank' href='https://www.openstreetmap.org'>Open  Street Map</a>, <a target='_blank' href='https://www.wikipedia.org/'>Wikipedia</a> and <a     target='_blank' href='https://earth.google.com/web/'>Google Earth</a>. It maps 4000 years of historic   rulers (polictical entities), cultures, and religions on a map linking to related Wikipedia articles   as well as various kinds of different markers such as people, battles, cities, castles etc. All of those can be linked to express a relation of each other (for example linking the siege of a city to   the specific city marker). On top of that, other kinds of media such as videos, images or podcasts can   be linked to create an even bigger knowledge web. Users can rate, edit and add new markers, area   entities or media items and create links all tracked by a revision history system. They can also ask   questions on specific articles and create article collections (called Epics) on major topics such as   wars or explorations (all area entities are on default Epics). A video showcasing those features can   be found ",
      "about3": "here",
      "about4": "<h5>From the beginning</h5> <p>The name <b>Chronas</b> is a combination of <b>Chron</b>os and Atl<b>as</b> indicating the   chronological and cartographical approach of the history application.</p> <p>The initial idea in mid-2014 was to add a time slider to a Google Maps like application, making it   possible to travel back in time: watching realms being founded, grow and disappear again. The goal was   to get a better understanding of how the world's history is interconnected. <i>What happened in Asia     when Rome dominated Europe? What happened in Arabia when Kublai Khan proclaimed himself the emperor     of China?</i></p> <p>The original version of Chronas was released in 2015 and attracted over 5000 registered users. It was   based on a fork of <a target='_blank' href='https://umap.openstreetmap.fr/en'>Open Street Map</a> and   used the raster map library <a target='_blank' href='https://leafletjs.com/'>Leaflet</a> with the   relational <a target='_blank' href='https://www.postgresql.org/'>PostgreSQL</a> database. </p> <p>   Here is a ~5 min video showing the basic features of the original version: </p>",
      "about5": "<p>   If you are interested in trying out the original version, it is still available at <a target='_blank'     href='http://v0.chronas.org'>http://v0.chronas.org</a>.   It also includes the <a target='_blank' href='http://v0.chronas.org/blog'>development blog</a> which   explains in more detail the technical approach of the initial version as well as two 3D spin-off apps   showing <a target='_blank' href='http://app.chronas.org/castles/#/wikidata'>castles</a> and <a     target='_blank' href='http://app.chronas.org/battles/#/wikidata'>battles</a> by wikipedia language. </p> <br /> <p>   Development of the current version of Chronas began in July 2017 and represented a complete rewrite of   logic and architecture focusing on improved performance as well as easy edits, revisions and linking   related articles. In place of Leaflet, the WebGL map library <a target='_blank'     href='https://www.mapbox.com/mapbox-gl-js/api/'>Mapbox   GL</a> was used with a <a target='_blank' href='https://reactjs.org/'>React JS</a> UI. For the backend   a dedicated API written in <a target='_blank' href='https://expressjs.com'>Express</a> <a     target='_blank' href='https://nodejs.org/'>Node JS</a> uses a NoSQL <a target='_blank'       href='https://nodejs.org/'>Mongo</a> database   for complex queries and revisioning. </p> <p>You can find a detailed feature walkthrough of the new Chronas version in the <b>How To</b> section.</p>",
      "contact1": "Developers",
      "contact2": "Founder and Front and Backend Development",
      "contact3": "Co-Founder and Technical Lead",
      "contact4": "Translations by",
      "contact5": "Contact",
      "contact6": "Send us an email directly (hover over the email icon to display our email addresses) or use the form below:",
      "contact7": "Your Email Address*",
      "contact8": "Subject*",
      "contact9": "Message*",
      "contact10": "Send",
      "howTo1": "How to use in about 5 minute",
      "howTo2": "How to edit data in about 6 minutes (with English commentary)",
      "pledge1": "You have now been on Chronas for over <b>15 minutes</b>!",
      "pledge2": "Chronas depends on user support to survive and grow. If you find this project useful head over to ",
      "pledge3": " and consider pledging an amount of your choice.",
      "pledge4": "Patreons will be able to steer the project by voting on feature priorities and major design decisions.",
      "pledge5": "If you don't like to use Patreon, one time contributions are possible via PayPal:",
      "rules1": "<br /> <h4>Rules For Data Curation</h4> <ol>   <li><i>No Vandalism</i>: This is not the place to paint an alternative history map. Vandalism hurts     the project immensely (costly backups) and will get you banned.   </li>   <li><i>Watch the tutorial videos</i> before you start editing. Some controls may lead     to <i>unwanted</i> results.   </li>   <li>Your data inputs should be based on <i>accepted history</i> and you should be ready to cite     sources if asked.   </li>   <li><i>Report</i> Users That Break those Rules.</li> </ol> <br /> <h4>Rules For The Forums</h4> <ol>   <li><i>No Vandalism</i>: No Racism, Bigotry, or Offensive Behavior.</li>   <li>Ask <i>Clear and Specific Questions</i>, with <i>Time and Place in Mind</i>.</li>   <li>Provide preferably <i>Primary and Secondary Sources</i> If Asked Rather Than Tertiary Sources     Like <i>Wikipedia</i>.   </li>   <li>Serious On-Topic Questions Only: <i>No Jokes</i>, <i>Anecdotes</i>, <i>Clutter</i>, or     other <i>Digressions</i>.   </li>   <li><i>Report</i> Answers That Break those Rules.</li> </ol>",
      "statistics1": "The following statistics are live data counts and represent a snapshot of the current Chronas database",
      "statistics2": "Map Datapoints",
      "statistics3": "Users and Engagements",
      "statistics4": "Marker Breakdown",
      "statistics5": "Map Datapoints",
      "statistics6": "Details",
      "statistics7": "Media Breakdown",
      "statistics8": "Users By Auth Type",
      "statisticsTooltip1": "Area datapoints: 4000 years mapped with 2479 provinces with 4 dimensions",
      "statisticsTooltip2": "Markers include people and battle markers, but also cities etc",
      "statisticsTooltip3": "Media includes media (videos, images...) as well as epics (compilation of articles)",
      "statisticsTooltip4": "Number of unique area entities for rulers, cultures and religions",
      "statisticsTooltip5": "Signed up users",
      "statisticsTooltip6": "Edits made to the data by users",
      "statisticsTooltip7": "Forum threads (includes auto-generated and migrated threads)",
      "statisticsTooltip8": "Forum comments (includes auto-generated and migrated replies)",
      "support1": "There are a couple of ways to finance the upkeep and the development of new features and fixing of   issues. For example Wikipedia or public broadcasters use reoccurring campaigns to raise donations (<b>pledge   drives</b>), many web applications use <b>advertisements</b> (which can decrease the useability/   enjoyment of the app). Another way is to introduce a <b>pro version</b> or try to find <b>venture   capital investors</b>.",
      "support10": " the developers.",
      "support11": "If you are interested in running Chronas on your (or our) server with a complete data replica of which you are in complete control, ",
      "support12": "contact",
      "support13": " us and we are happy to discuss further.",
      "support2": "We decided to try out yet another funding model which gives the <b>sustaining users</b> who ensure the   future of Chronas also the ability to decide where the journey is headed. If you believe in our   project, please consider supporting us on",
      "support3": " where we will have regular <b>votes</b> on the priority of proposed <b>new features</b> as well as <b>major design decisions</b>.",
      "support4": "If you don't like to use Patreon, one time contributions are possible via PayPal:",
      "support5": "New Features",
      "support6": "You can propose features in the feature request ",
      "support7": "forum",
      "support8": " or by directly ",
      "support9": "contacting",
      "welcome11": "<b>Chronas</b> is a history map application with over ",
      "welcome12": "50 million data points",
      "welcome13": " which users can curate and contribute to (similar to <a>Wikipedia</a>).",
      "welcome21": "Before you dive in, make sure to watch the short ",
      "welcome22": "Tutorial Video",
      "welcome23": " in the How To section.",
      "welcome31": "Join",
      "welcome32": " our community of <b>%{dontTranslate}</b> members to add and edit data, earn points, ask questions about history articles and access our ",
      "welcome33": "Forums",
      "welcome34": " to suggest new features and report bugs.",
      "welcome41": "Visit the ",
      "welcome42": "About",
      "welcome43": " If you have any inquiries, comments or questions, please use the ",
      "welcome44": "Contact",
      "welcome45": " form.",
      "welcome51": "We believe in the potential of this project to become a popular history tool alongside Wikipedia. If you share our enthusiasm and want to see the project succeed, please consider becoming a sustainer. For more information on <b>support</b> and the <b>future of Chronas</b>, visit the ",
      "welcome52": "Support",
      "welcome53": " section."
    },
    "clusterMarker": "Cluster Marker",
    "community": "Community Board",
    "configuration": "Configuration",
    "discover": "Discover",
    "discover_component": {
      "seeMore1": "See more media in the ",
      "seeMore2": " section...",
      "noFound": "No images found",
      "noGeotaggedFound": "No geotagged images found in this location, see Discover section for all available images",
      "edit": "Edit this item",
      "hasNoArticle": "No Wiki article linked yet, please consider editing this item",
      "hasNoSource": "No source linked yet, please consider editing this item",
      "openArticle": "Open related Wikipedia article",
      "openSource": "Open in new tab",
      "tabs": {
        "HIGHLIGHTS": "HIGHLIGHTS",
        "ARTEFACTS": "ARTEFACTS",
        "EPICS": "EPICS",
        "PEOPLE": "PEOPLE",
        "CITIES": "CITIES",
        "BATTLES": "BATTLES",
        "OTHER": "OTHER",
        "VIDEOS": "VIDEOS",
        "PRIMARY SOURCES": "PRIMARY SOURCES"
      },
    },
    "discover_label": "Discover the year ",
    "downvote": "Inappropriate, broken or inaccurate",
    "play": {
      "start": "Start"
    },
    "edu": {
      "studentSign": "Go to lesson",
      "studentName": "Your Name"
    },
    "edit": "Edit",
    "epicIdNameArray": {
      "ee": "Exploration",
      "ei": "Discovery",
      "eo": "Other Epic",
      "es": "Primary Source",
      "ew": "War"
    },
    "epics": "Epics",
    "migration": "Migration",
    "feedbackSuccess": "Thanks for curating the data!",
    "flags": "Reported as inaccurate data",
    "flag": "Flag as inaccurate data",
    "unflag": "Unflag inaccurate data",
    "filterMedia": "Filter Media",
    "filter": "Filter",
    "fontType": "Font Type",
    "founded": "est.",
    "fullscreenArticle": "Fullscreen Article",
    "openArticleInNewTab": "Open article in new tab",
    "general": "General",
    "goFullScreen": "Fullscreen",
    "goTutorial": "Go to Tutorial",
    "help": "Intro and Information",
    "images": "Images",
    "info": {
      "followUs": "Follow us on",
      "lastDataEdit": "last data edit",
      "tabs": {
        "about": "About",
        "contact": "Contact",
        "howTo": "How To",
        "rules": "Rules",
        "statistics": "Statistics",
        "support": "Support",
        "welcome": "Welcome"
      },
      "welcomeTo": "Welcome to"
    },
    "information": "Information",
    "label": "Label",
    "language": "Language",
    "layers": "Layers",
    "linkedTypes": {
      "artefacts": "[Image] Artefact",
      "audios": "[Podcast & Audio]",
      "battles": "[Image] Battle",
      "cities": "[Image] City & Building",
      "eb": "[Epic] Biography",
      "ee": "[Epic] Explorations",
      "ei": "[Epic] Discoveries",
      "eo": "[Epic] Other",
      "ew": "[Epic] Wars",
      "h": "[HTML or Text]",
      "misc": "[Image] Other",
      "o": "Other",
      "people": "[Image] Person",
      "ps": "[Link] Primary Source",
      "v": "[Video]",
      "w|a": "[Wiki Article] People -> Artists",
      "w|ar": "[Wiki Article] Artifacts",
      "w|at": "[Wiki Article] People -> Athletes",
      "w|b": "[Wiki Article] Battles -> Battles",
      "w|c": "[Wiki Article] Cities -> Cities",
      "w|ca": "[Wiki Article] Cities -> Castles",
      "w|e": "[Wiki Article] People -> Explorers",
      "w|l": "[Wiki Article] Other -> Landmark",
      "w|m": "[Wiki Article] People -> Military",
      "w|o": "[Wiki Article] Other -> Unknown",
      "w|op": "[Wiki Article] People -> Unclassified",
      "w|p": "[Wiki Article] People -> Politicians",
      "w|r": "[Wiki Article] People -> Religious",
      "w|s": "[Wiki Article] People -> Scientists",
      "w|si": "[Wiki Article] Battles -> Sieges"
    },
    "loading": "loading...",
    "localeWikiNotFound": "Could not find English article",
    "map": "",
    "markerIdNameArray": {
      "Artifact": "Artifact",
      "Artist": "Artists",
      "Athlete": "Athletes",
      "Battle": "Battle",
      "Capital": "Capital",
      "Castle": "Castle",
      "City": "City",
      "Explorer": "Explorer",
      "Landmark": "Landmark",
      "Military": "Military",
      "Politician": "Politician",
      "Religious": "Religious",
      "Scientist": "Scientists",
      "Siege": "Siege",
      "Unclassified": "Unclassified",
      "Unknown": "Unknown"
    },
    "markerLimit": "Marker Limit",
    "markerMetadataTypes": {
      "a": "Artist",
      "ae|culture": "Culture",
      "ae|religion": "Religion",
      "ae|religionGeneral": "Religion General",
      "ae|ruler": "Ruler",
      "ar": "Artifact",
      "at": "Athlete",
      "b": "Battle",
      "c": "City",
      "ca": "Castle",
      "cp": "Capital",
      "e": "Explorer",
      "ee": "Exploration",
      "ei": "Discovery",
      "eo": "Other Epic",
      "es": "Primary Source",
      "ew": "War",
      "l": "Landmark",
      "m": "Military",
      "o": "Unknown",
      "op": "Unclassified",
      "p": "Politician",
      "ps": "Primary Source",
      "r": "Religious",
      "s": "Scientist",
      "si": "Siege"
    },
    "markers": "Markers",
    "markersMedia": "Markers & Media",
    "markerType": "Marker Type",
    "markerTypes": {
      "abstract": "Abstract",
      "themed": "Themed"
    },
    "markerCheckAll": "Select All Marker",
    "markerUncheckAll": "Hide All Marker",
    "mediaTitle": "Media: %{dontTranslate}",
    "metadata": "Metadata",
    "migrationTooltip": "Displays routes from people place of birth to place of death and aggregates per location.",
    "minimize": "Minimize",
    "mod": "Modification",
    "next": "next",
    "noLinkedContents": "There are no linked media items yet, consider adding and linking one.",
    "opacityByPopulation": "Opacity By Population",
    "openArticle": "Open Article",
    "openEpic": "Open Own Epic",
    "openImage": "Open Image",
    "openSource": "Open Source",
    "partOf": "Part Of",
    "pledgeOpen": "Open Patreon in new tab",
    "pledgeRemind": "Remind me in another 15 minutes",
    "pledgeTitle": "Hey there traveler!",
    "pointsAdded": "Points added to your account",
    "privacyPolicy": "Privacy Policy",
    "random": "Random Article",
    "readDocument": "Read Document",
    "related_item": "RELATED ITEMS...",
    "browse_item": "BROWSE ITEMS...",
    "resources": "Resources",
    "revisionHistory": "Revision history",
    "revisions": "Revisions",
    "allRevisions": "All Revisions",
    "search": "Search",
    "searchMarkers": "Search Markers",
    "setYearByArticle": "Change year by article",
    "share": "Share as link or export image",
    "showProvinces": "Show Provinces",
    "signupToGatherPoints": "Sign up to get points for your curations",
    "skipTutorial": "I know what I am doing (skip tutorial)",
    "startTyping": "Start typing",
    "statistics": {
      "area": "Area",
      "edits": "Edits",
      "entities": "Entities",
      "markers": "Markers",
      "media": "Media",
      "replies": "Replies",
      "threads": "Threads",
      "users": "Users"
    },
    "termsofService": "Terms of Service",
    "theme": {
      "dark": "Dark",
      "font": "Font",
      "light": "Light",
      "luther": "Concordia",
      "marker": "Marker",
      "name": "Theme"
    },
    "timeline": {
      "openAutoplayMenu": "Open Autoplay Menu",
      "stopAutoplay": "Stop Autoplay",
      "autoplay": "Autoplay",
      "autoplaySubtitle": "Changes year by step size",
      "stepSize": "Step Size in Years",
      "expand": "Expand Timeline",
      "delay": "Delay in sec",
      "repeat": "Repeat",
      "reset": "Reset Timeline View",
      "startSlideshow": "Start Slideshow",
      "searchEpics": "Search Epics"
    },
    "toggle": "Toggle",
    "upvote": "Interesting and accurate",
    "users": "Manage Users",
    "welcome": "Welcome"
  },
  "resources": {
    "areas": {
      "fields": {
        "capital": "Capital",
        "color": "Area Color",
        "culture": "Culture",
        "display_name": "Display Name",
        "endYear": "Until Year",
        "genReligion": "General Religion",
        "icon_url": "Icon (Full commons.wikimedia or Wikipedia URL)",
        "key": "Entity Key",
        "main_religion_name": "Main Religion Name",
        "main_ruler_name": "Main Ruler Name",
        "population": "Population",
        "province": "Province",
        "province_list": "Click on provinces to select/ deselect",
        "religion": "Religion",
        "religionGen": "Religion Gen.",
        "replaceWith": "Replace With",
        "ruler": "Ruler",
        "search_name": "Select By Name",
        "startYear": "From Year",
        "wiki_url": "Article (Full Wikipedia URL)"
      }
    },
    "flags": {
      "fields": {
        "fixed": "Resolved",
        "subEntityId": "SubEntityId",
        "fullUrl": "FullUrl",
        "wrongWiki": "wrongWiki"
      }
    },
    "linked": {
      "fields": {
        "allowClickAway": "Allow Clickaway",
        "drawRoute": "Draw Route",
        "isStory": "Is Storyline (using HTML slides)?",
        "changeYearByArticle": "Change Year By Article",
        "type": "Type",
        "content": "Description",
        "description": "Title",
        "geojson": "Geojson (for epics)",
        "onlyEpicContent": "Only used as linked part of another article (you will be forwarded to the link form upon saving)",
        "collectionDescription": "Description",
        "poster": "Link to poster image",
        "source": "Link to source",
        "src": "Link to source/ ID",
        "subtype": "Type",
        "makePublic": "Make Public",
        "wiki": "Associated Wikipedia Article",
        "year": "Year"
      }
    },
    "links": {
      "fields": {
        "content_list": "Items to appear in the left content list section",
        "media_list": "Items to appear in the media section",
        "source": "Source article receiving links"
      }
    },
    "markers": {
      "deleted": "Marker Deleted",
      "fields": {
        "capitalEnd": "End Year",
        "capitalOwner": "Capital Ruler",
        "capitalStart": "Start Year",
        "coo": "Coordinates",
        "date": "Date",
        "endYear": "Year End",
        "lastUpdated": "Last Updated",
        "lat": "Latitude",
        "lng": "Longitude",
        "name": "Name",
        "rating": "Rating",
        "startYear": "Year Start",
        "subtype": "Subtype",
        "type": "Type",
        "url": "URL",
        "year": "Year"
      },
      "name": "Marker |||| Markers",
      "place_marker": "Place Marker",
      "tabs": {
        "reviews": "Reviews",
        "stats": "Stats"
      }
    },
    "page": {
      "delete": "Delete"
    },
    "revisions": {
      "fields": {
        "entityId": "Entity Id",
        "id": "Id",
        "name": "Name",
        "nextBody": "Next Body",
        "prevBody": "Prev Body",
        "resource": "Resource",
        "reverted": "Reverted",
        "subtype": "Subtype",
        "timestamp": "Timestamp",
        "type": "Type",
        "user": "User"
      },
      "name": "Revision |||| Revisions"
    },
    "users": {
      "fields": {
        "createdAt": "Created at",
        "education": "Education",
        "email": "Email",
        "karma": "Karma",
        "name": "Name",
        "privilege": "Privilege",
        "username": "Username"
      },
      "name": "User |||| Users",
      "page": {
        "delete": "Delete Account"
      },
    }
  },
  "somethingWentWrong": "Something went wrong"
}
